import React from 'react'
import PropTypes from 'prop-types'
import ThemeEditorCard from './ThemeEditorCard'
import ThemeTypeCard from './ThemeTypeCard'
import ThemeLogoUpload from './ThemeLogoUpload'
import ThemePresets from './ThemePresets'

const paletteFields = {
  background: [
    { label: 'Paper', name: 'paper' },
    { label: 'Default', name: 'default' },
  ],
  primary: [{ label: 'Main', name: 'main' }],
  secondary: [{ label: 'Main', name: 'main' }],
  oddsButton: [{ label: 'Default', name: 'default' }],
}

const ThemeEditor = props => {
  const { theme, setTheme } = props

  const handleChangeTheme = (name, changes) => {
    setTheme({
      ...theme,
      palette: {
        ...theme.palette,
        [name]: changes,
      },
    })
  }

  const handleChangeThemeType = event => {
    const type = event.target.value
    setTheme({
      ...theme,
      palette: {
        ...theme.palette,
        type: event.target.value,
        background: {
          paper: type === 'light' ? '#fff' : '#222326',
          default: type === 'light' ? '#F4F7FB' : '#121212',
        },
        oddsButton: {
          default: 'rgba(255, 255, 255, .1)',
          hover: 'rgba(255, 255, 255, .15)',
        },
      },
    })
  }

  return (
    <>
      <ThemePresets theme={theme} setTheme={setTheme} />
      <ThemeTypeCard
        type={theme.palette.type}
        onChange={handleChangeThemeType}
      />
      <ThemeEditorCard
        label="Background"
        name="background"
        fields={paletteFields.background}
        onChange={handleChangeTheme}
        palette={theme.palette.background}
      />
      <ThemeEditorCard
        label="Primary"
        name="primary"
        fields={paletteFields.primary}
        onChange={handleChangeTheme}
        palette={theme.palette.primary}
      />
      <ThemeEditorCard
        label="Secondary"
        name="secondary"
        fields={paletteFields.secondary}
        onChange={handleChangeTheme}
        palette={theme.palette.secondary}
      />
      <ThemeEditorCard
        label="Odds Button"
        name="oddsButton"
        fields={paletteFields.oddsButton}
        onChange={handleChangeTheme}
        palette={theme.palette.oddsButton}
      />
      <ThemeLogoUpload theme={theme} setTheme={setTheme}></ThemeLogoUpload>
    </>
  )
}

ThemeEditor.propTypes = {
  theme: PropTypes.object,
  setTheme: PropTypes.func,
}

export default ThemeEditor
